import { render, staticRenderFns } from "./FormInputColorPicker.vue?vue&type=template&id=163191d6"
import script from "./FormInputColorPicker.vue?vue&type=script&lang=js"
export * from "./FormInputColorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports